import { render } from "./AtendimentoFuncaoAtualRelatorio.vue?vue&type=template&id=594b6cae&scoped=true"
import script from "./AtendimentoFuncaoAtualRelatorio.vue?vue&type=script&lang=js"
export * from "./AtendimentoFuncaoAtualRelatorio.vue?vue&type=script&lang=js"

import "./AtendimentoFuncaoAtualRelatorio.vue?vue&type=style&index=0&id=594b6cae&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594b6cae"]])

export default __exports__